import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-layout-wrapper', $options.rootClasses])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}